module.exports = __webpack_public_path__ + "static/media/arrow-right-white.df3fc809.svg";